export function etiquetaError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}

export function setEstados(state, payload){
    state.estados = payload.data.estados    
    state.error= false
    state.errorMessage = ''
}

export function flushEstados(state){
    state.estados = []
    state.error= false
    state.errorMessage = ''
}

export function setCategorias(state, payload){
    state.categorias = payload.data.categorias
    state.error= false
    state.errorMessage = ''
}

export function flushCategorias(state){
    state.categorias = []
    state.error= false
    state.errorMessage = ''
}

export function setEtiquetas(state, payload){
    state.etiquetas = payload.data.etiquetas
    state.error= false
    state.errorMessage = ''
}

export function setTotalCategorias(state, payload){
    state.totalCategorias = payload.data.totalcategorias
    state.error= false
    state.errorMessage = ''
}